const fileSuffixRegex = /\.[^.]*$/;
export { fileSuffixRegex, };
